import React from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";
import Link from "gatsby-link";
import "./PageLayout.css";
import "../css/reset.css";
import "../css/loader.css";
import { GridLoader } from "react-spinners";
import Header from "../components/TopNavigationBar";
import SidebarMobile from "../components/SidebarMobile";
import PreloaderSection from "../components/preloaderSection";
import "../css/main.css";
// import Address from "../components/Address"
// import Modal from "../components/Modal"
import { Button } from "react-bootstrap";
import { validationForEmail } from "../js/regex";
import axios from "axios";
import { Provider } from "react-redux";
import createStore from "../state/createStore";
const store = createStore();
const BeLogo =
  "https://bawamasalacompany.com/assets/images/BE(LOGO)footer200x200.png";
const LOGO = "https://www.jayceepower.com/images/newImages/JC_updated_logo.png";

export class PageLayout extends React.Component {
  constructor(agrs) {
    super(agrs);
    this.state = {
      isLoading: true,
      isShowSidebar: false,
      activeRouteName: "",
      show: true,
    };
  }
  // componentDidMount () {
  // 	setTimeout(() => {
  // 		this.setState({
  // 			isLoading: !this.state.isLoading
  // 		})
  // 	}, 100)
  // }
  componentWillMount() {
    setTimeout(() => {
      this.setState({
        isLoading: !this.state.isLoading,
      });
    }, 0);
  }
  toggleSidebar = () => {
    this.setState({
      isShowSidebar: !this.state.isShowSidebar,
    });
  };
  toggleModal = () => {
    this.setState({
      show: !this.state.show,
    });
  };
  handleEmail = (e) => {
    e.preventDefault();
    this.setState({
      subscriberEmail: e.target.value,
    });
  };
  submitEmail = () => {
    if (validationForEmail(this.state.subscriberEmail)) {
      // console.log("submit")
      this.setState({
        emailError: false,
        isSubmittingEmail: true,
      });
      let emailParams = `email=${this.state.subscriberEmail}`;
      axios
        .get(
          `https://blackelephantdigital.in/blackele/sunny/api/winpe-api/public/newsletter_subscriber?${emailParams}`
        )
        .then((response) => {
          let { data } = response;
          if (data === "Success") {
            this.setState({
              isSubmitted: true,
              isSubmittingEmail: false,
            });
          } else {
            this.setState({
              emailError: "This email is already subcribed",
              isSubmittingEmail: false,
            });
          }
        });
    } else {
      this.setState({
        emailError: "Please enter a valid email address",
      });
    }
  };
  render() {
    const { children, location } = this.props;
    const {
      isShowSidebar,
      activeRouteName,
      isModalOpen,
      isLoading,
    } = this.state;
    const appChildren =
      process.env.NODE_ENV === "production"
        ? children({ location })
        : children();
    let route = location.pathname.split("/")[1];
    let activeRoute = location.hash;
    return (
      <Provider store={store}>
        <div
          className={
            isLoading && route === "" ? "body__overflow__none" : "not_dis"
          }
        >
          {isLoading ? (
            <div className="loader__class">
              {/* <PreloaderSection loading={isLoading} /> */}
            </div>
          ) : null}
          <div className="page-layout__viewport">
            <div className="page-layout__viewport__header">
              <div className="menu__bar">
                <MediaQuery query="(min-width: 1224px)">
                  <Header />
                </MediaQuery>
                <MediaQuery query="(max-width: 1223px)">
                  <span>
                    <span className="logo">
                      <Link to="/home">
                        <img
                          src={LOGO}
                          alt="WinPe Logo"
                          className="mobile__logo"
                        />
                      </Link>
                    </span>
                    <span
                      className="hmb pull-right"
                      onClick={this.toggleSidebar}
                    >
                      <i className="fa fa-bars" />
                    </span>
                    <SidebarMobile
                      show={isShowSidebar}
                      onHide={this.toggleSidebar}
                      activePathname={activeRoute}
                    />
                  </span>
                </MediaQuery>
              </div>
            </div>
            <MediaQuery query="(min-width: 1224px)">
              <div className="page-layout__viewport__left_content">
                <div className="social__icons">
                  <div className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.facebook.com/Jaycee-Punching-Solution-Pvt-Ltd-427742187329739/"
                      target="_blank"
                      className=""
                    >
                      <i className="fa fa-facebook"></i>
                    </a>
                  </div>
                  <div className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://twitter.com/jaycee_power"
                      target="_blank"
                      className=""
                    >
                      <i className="fa fa-twitter"></i>
                    </a>
                  </div>
                  <div className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.linkedin.com/company/jaycee-punching-solutions-pvt-ltd/"
                      target="_blank"
                      className=""
                    >
                      <i className="fa fa-linkedin"></i>
                    </a>
                  </div>
                  <div className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.instagram.com/jayceeenergy"
                      target="_blank"
                      className=""
                    >
                      <i className="fa fa-instagram"></i>
                    </a>
                  </div>
                  <div className="icon">
                    <a
                      rel="noopener noreferrer"
                      href="https://www.youtube.com/channel/UCWjyBBfhHJxgMinIWaVzmPA"
                      target="_blank"
                      className=""
                    >
                      <i className="fa fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
            </MediaQuery>
            <div className="page-layout__viewport__middle_content">
              {appChildren}
            </div>
            <div className="page-layout__viewport__footer_content">
              <div className="row">
                <div className="col-md-4 col-sm-4">
                  <div className="left__content">
                    © Jaycee Punching Solutions Pvt. Ltd.{" "}
                    {new Date().getFullYear()}. All Rights Reserved.
                  </div>
                </div>
                <div className="col-md-4 col-sm-4">
                  <div className="middle__content"></div>
                </div>
                <div className="col-md-4 col-sm-4">
                  <div className="right__content">
                    Powered By{" "}
                    <a
                      href="https://blackelephantdigital.com"
                      rel="noopener noreferrer"
                      target="_blank"
                      className=""
                    >
                      <img
                        src={BeLogo}
                        style={{ width: "30px", marginLeft: "10px" }}
                        alt="Black Elephant digital logo"
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Provider>
    );
  }
}

PageLayout.propTypes = {
  children: PropTypes.func,
  location: PropTypes.object,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/layouts/index.jsx